import { useState } from 'react';

import type { FrameLayout } from '../components/app_frame';

const STORAGE_KEY = 'voll:view-as:frame';

function readStored(): FrameLayout {
  try {
    return globalThis.localStorage.getItem(STORAGE_KEY) === 'desktop' ? 'desktop' : 'phone';
  } catch {
    return 'phone';
  }
}

/**
 * Phone or desktop frame for "Ver como viajante": starts on the phone and
 * remembers the operator's last choice in this browser (a convenience — no
 * traveler data, nothing the server needs to know).
 */
export function useFrameLayout(): [FrameLayout, (next: FrameLayout) => void] {
  const [layout, setLayout] = useState<FrameLayout>(readStored);
  const choose = (next: FrameLayout): void => {
    setLayout(next);
    try {
      globalThis.localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // Storage blocked (private mode, policy): the choice lasts for this page only.
    }
  };
  return [layout, choose];
}
